import { Indicator, fetchFromOldApi } from '~/services/Http';

export const getAllIndicators = async (
  _: string,
  includeInactive: boolean,
): Promise<Indicator[]> => {
  return await (
    await fetchFromOldApi(
      `/json/solaintel/indicator?includeInactive=${includeInactive}`,
      {
        method: 'GET',
      },
    )
  ).json();
};

export const updateIndicator = async (
  indicator: Indicator,
): Promise<Indicator> => {
  return await (
    await fetchFromOldApi(
      `/json/solaintel/predefined-indicator/${indicator.id}/update`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          active: indicator.active,
          config: indicator.config,
        }),
      },
    )
  ).json();
};
